import script from "./pButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./pButton.vue?vue&type=script&lang=ts&setup=true"

import "./styles/pButton.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__